import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { Folder } from 'modules/documents/hooks/useGetFolders'
import { ALL_TYPES } from 'modules/documents/lib/constants'

import InformationLink from './InformationLink'

interface Props {
  employeeId: number
  companyId: number
  legalEntityId: number
  folders: Folder[]
}

const Contract = ({ employeeId, companyId, legalEntityId, folders }: Props) => {
  const { navigation } = useNavigation()

  const contractFolders = folders.filter((folder) => folder.url == ALL_TYPES['contract'])
  const contractFolderId = contractFolders[0]?.id

  return (
    <>
      <InformationLink
        href={`${navigation.employees.id.contractVersions.fullPath({
          id: employeeId,
        })}?switchToCompanyId=${companyId}`}
        label={i18n.t('bookkeepers.incidence.details.see_employee_contract')}
      />
      <InformationLink
        href={`${navigation.employees.id.documents.folderId.fullPath({
          id: employeeId,
          folderId: Number(contractFolderId),
        })}?switchToCompanyId=${companyId}`}
        label={i18n.t('bookkeepers.incidence.details.see_employee_contract_documents')}
      />
      <InformationLink
        href={`${navigation.settings.legalEntitiesId.fullPath({
          id: legalEntityId,
        })}?switchToCompanyId=${companyId}`}
        label={i18n.t('bookkeepers.incidence.details.see_legal_entity')}
      />
    </>
  )
}

export default Contract
